module.exports = __webpack_public_path__ + "static/img/wyfw2.8712bb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfw2.png
// module id = wFLq
// module chunks = 1